import React from "react"
import { MutedcheckMark } from "@/components/Icons"
import { isBlank } from "@/utils"
import {
  calculateTotalMaximumCapacity,
  RenderDeparturesColumn,
  RenderIssuesColumn,
} from "./Helpers"

const TableRow = ({ tour }) => {
  const hasClosedDayRequest = tour.issues.some((obj) => obj.kind === "day_expected_open")
  const hasOpenDayRequest = tour.issues.some((obj) => obj.kind === "day_expected_closed")
  const isTourClosed = tour.closedDay && !tour.closedDay?.discardedAt
  const isClosedDay = isTourClosed && !hasOpenDayRequest
  const displayTotalCapacity = !(isClosedDay || hasClosedDayRequest) && !isBlank(tour.departures)
  const displayDepartures = isClosedDay || hasClosedDayRequest || !isBlank(tour.departures)

  return (
    <tr>
      <td />
      <td />
      <td />
      <td style={{ color: "#888888" }}>
        <strong>{tour.code}</strong> <br />
        {isBlank(tour.constraints.allotmentConstraint) ||
        (isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMin) &&
          isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMax) &&
          isBlank(tour.constraints.allotmentConstraint.capacityPerDayMax)) ? (
          <div>
            No requirement
            <br /> loaded
          </div>
        ) : (
          <>
            {!isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMin) && (
              <>
                <span>
                  Min per departure: {tour.constraints.allotmentConstraint.capacityPerDepartureMin}
                </span>
                <br />
              </>
            )}

            {!isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMax) && (
              <>
                <span className="me-1">Max per departure:</span>
                <span>{tour.constraints.allotmentConstraint.capacityPerDepartureMax}</span>
                <br />
              </>
            )}

            {!isBlank(tour.constraints.allotmentConstraint.capacityPerDayMax) && (
              <>
                <span className="me-1">Max per day:</span>
                <span>{tour.constraints.allotmentConstraint.capacityPerDayMax}</span>
              </>
            )}
          </>
        )}
      </td>
      <td style={{ color: "#888888" }}>
        {displayDepartures && (
          <RenderDeparturesColumn
            departures={tour.departures}
            property="departureTime"
            closed={isClosedDay || hasClosedDayRequest}
            additionalData
          />
        )}
      </td>
      <td style={{ color: "#888888" }}>
        {displayDepartures && (
          <RenderDeparturesColumn
            departures={tour.departures}
            property="durationInMinutes"
            closed={isClosedDay || hasClosedDayRequest}
            additionalData
          />
        )}
      </td>
      <td style={{ color: "#888888" }}>
        {displayDepartures && (
          <RenderDeparturesColumn
            departures={tour.departures}
            property="minimumCapacity"
            closed={isClosedDay || hasClosedDayRequest}
            additionalData
          />
        )}
      </td>
      <td style={{ color: "#888888" }}>
        {displayDepartures && (
          <>
            <RenderDeparturesColumn
              departures={tour.departures}
              property="maximumCapacity"
              closed={isClosedDay || hasClosedDayRequest}
              additionalData
            />
            {displayTotalCapacity && (
              <strong> {`${calculateTotalMaximumCapacity(tour.departures)} (Total)`}</strong>
            )}
          </>
        )}
      </td>
      <td style={{ color: "#888888" }}>
        {!isBlank(tour.issues) && <RenderIssuesColumn issues={tour.issues} />}
      </td>
      <td style={{ color: "#888888" }}>
        {tour.state == "Approved" && <MutedcheckMark />} {tour.state}
      </td>
      <td />
      <td />
      <td />
    </tr>
  )
}

const AdditionalTours = ({ inventory }) =>
  inventory.map((tour) => (
    <React.Fragment key={tour.code}>
      <TableRow tour={tour} />
    </React.Fragment>
  ))

export default AdditionalTours
